"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastFeedErrorCode = void 0;
var PodcastFeedErrorCode;
(function (PodcastFeedErrorCode) {
    PodcastFeedErrorCode["FEED_FETCHING_FAILED"] = "FEED_FETCHING_FAILED";
    PodcastFeedErrorCode["FEED_FORMAT_NOT_VALID"] = "FEED_FORMAT_NOT_VALID";
    PodcastFeedErrorCode["EPISODE_NOT_FOUND"] = "EPISODE_NOT_FOUND";
})(PodcastFeedErrorCode || (PodcastFeedErrorCode = {}));
exports.PodcastFeedErrorCode = PodcastFeedErrorCode;
//# sourceMappingURL=types.js.map